<template>
  <div class="content-card-plans">
    <a class="content-card-plans-link" @click="routerPage(dayOfTheWeek)">
      <div class="content-card-plans--text">
        <h3>{{ dayOfTheWeek.name }}</h3>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    dayOfTheWeek: {
      type: Object,
      required: true,
    },
  },
  methods: {
    routerPage(dayOfTheWeek) {
      this.$router.push({
        name: "EditDayOfTheWeek",
        params: {
          id: dayOfTheWeek.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-card-plans {
  height: 200px;
  display: block;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-bottom: 30px;
  &-link {
    height: 100%;
    transition: 500ms;
    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  &--text {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
    height: 100%;
    h3 {
      font-size: 20px;
      font-family: "Font Semibold";
      color: var(--black);
      margin-bottom: 10px;
      @media (min-width: 577px) {
        height: 50px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    p {
      font-size: 14px;
      font-family: "Font Light";
      color: var(--black);
      margin-bottom: 0;
      @media (min-width: 577px) {
        height: 65px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
  &-btn {
    padding: 15px;
    .btn-yellow {
      margin-bottom: 0;
    }
  }
}
</style>
